import { render, staticRenderFns } from "./UserBackground.vue?vue&type=template&id=152607ec&scoped=true"
import script from "./UserBackground.vue?vue&type=script&lang=js"
export * from "./UserBackground.vue?vue&type=script&lang=js"
import style0 from "./UserBackground.vue?vue&type=style&index=0&id=152607ec&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "152607ec",
  null
  
)

export default component.exports